import {
  Box,Button,CircularProgress,Dialog,DialogActions,DialogContent,DialogTitle,FormControl,FormControlLabel,InputLabel,MenuItem,Radio,RadioGroup,Select,Stack,Switch,TextField,Typography,
} from "@mui/material";

function getVisitorPermissionDetail(details,code){
  return details.find(item=>item.value===code)||null;
}

function getInheritedLabel(detail){
  if(!detail) return "No permitido por el rol";
  return detail.inherited===true?"Permitido por el rol":"No permitido por el rol";
}

function getEffectiveLabel(detail,currentValue){
  if(currentValue===true) return "Permitido individualmente";
  if(currentValue===false) return "Denegado individualmente";
  return detail?.inherited===true?"Heredado: permitido":"Heredado: no permitido";
}

export default function ModalPersonPermissions({
  open,
  form,
  setForm,
  persons,
  accessPoints,
  schedules,
  saving,
  onClose,
  onSave,
  onPersonChange,
  visitorPermissionOptions,
  visitorPermissions,
  visitorPermissionDetails,
  visitorPermissionsLoading,
  onVisitorPermissionChange,
}){
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>{form.id?"Editar permiso individual":"Nuevo permiso individual"}</DialogTitle>

      <DialogContent>
        <Stack spacing={2.5} sx={{paddingTop:1}}>
          <FormControl fullWidth>
            <InputLabel>Usuario</InputLabel>
            <Select value={form.person} label="Usuario" onChange={onPersonChange}>
              {persons.filter(person=>person.is_active||person.id===Number(form.person)).map(person=>(
                <MenuItem key={person.id} value={person.id}>{person.name} - {person.identification}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel>Acceso</InputLabel>
            <Select value={form.access_point} label="Acceso" onChange={event=>setForm(previous=>({...previous,access_point:event.target.value}))}>
              {accessPoints.filter(accessPoint=>accessPoint.is_active||accessPoint.id===Number(form.access_point)).map(accessPoint=>(
                <MenuItem key={accessPoint.id} value={accessPoint.id}>{accessPoint.name}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel>Horario</InputLabel>
            <Select value={form.schedule} label="Horario" onChange={event=>setForm(previous=>({...previous,schedule:event.target.value}))}>
              <MenuItem value="">Sin horario</MenuItem>
              {schedules.filter(schedule=>schedule.is_active||schedule.id===Number(form.schedule)).map(schedule=>(
                <MenuItem key={schedule.id} value={schedule.id}>{schedule.name}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <Box sx={{border:"1px solid #e5e7eb",borderRadius:2,paddingX:2,paddingY:1}}>
            <Typography sx={{fontSize:13,fontWeight:800,marginBottom:0.5}}>Tipo de regla</Typography>

            <RadioGroup row value={form.is_allowed?"allow":"deny"} onChange={event=>setForm(previous=>({...previous,is_allowed:event.target.value==="allow"}))}>
              <FormControlLabel value="allow" control={<Radio/>} label="Permitir acceso"/>
              <FormControlLabel value="deny" control={<Radio/>} label="Denegar acceso"/>
            </RadioGroup>
          </Box>

          <Box sx={{border:"1px solid #e5e7eb",borderRadius:2,padding:2}}>
            <FormControlLabel
              control={
                <Switch
                  checked={form.limit_dates===true}
                  onChange={event=>{
                    const checked=event.target.checked;

                    setForm(previous=>({
                      ...previous,
                      limit_dates:checked,
                      valid_from:checked?previous.valid_from:"",
                      valid_until:checked?previous.valid_until:"",
                    }));
                  }}
                />
              }
              label="Limitar por fechas"
            />

            <Typography sx={{color:"#6b7280",fontSize:12,marginTop:0.3}}>
              Si está desactivado, el permiso individual no tendrá límite de fechas y seguirá respetando el horario semanal configurado.
            </Typography>

            {form.limit_dates&&(
              <Box sx={{display:"grid",gridTemplateColumns:{xs:"1fr",sm:"1fr 1fr"},gap:2,marginTop:2}}>
                <TextField fullWidth required type="date" label="Válido desde" value={form.valid_from} onChange={event=>setForm(previous=>({...previous,valid_from:event.target.value}))} InputLabelProps={{shrink:true}}/>
                <TextField fullWidth required type="date" label="Válido hasta" value={form.valid_until} onChange={event=>setForm(previous=>({...previous,valid_until:event.target.value}))} InputLabelProps={{shrink:true}}/>
              </Box>
            )}
          </Box>

          <Box sx={{border:"1px solid #e5e7eb",borderRadius:2,overflow:"hidden"}}>
            <Box sx={{padding:2,borderBottom:"1px solid #e5e7eb",backgroundColor:"#fafafa"}}>
              <Typography sx={{fontSize:14,fontWeight:800}}>Permisos individuales de visitantes</Typography>
              <Typography sx={{color:"#6b7280",fontSize:12,marginTop:0.4}}>
                Estos permisos tienen prioridad sobre los permisos heredados del rol. Puedes permitir, denegar o dejar que el usuario herede la configuración de su rol.
              </Typography>
            </Box>

            {!form.person?(
              <Box sx={{padding:2}}>
                <Typography sx={{color:"#6b7280",fontSize:13}}>Selecciona primero un usuario para consultar sus permisos heredados.</Typography>
              </Box>
            ):visitorPermissionsLoading?(
              <Box sx={{minHeight:140,display:"flex",alignItems:"center",justifyContent:"center"}}>
                <CircularProgress size={24}/>
              </Box>
            ):(
              <Stack>
                {visitorPermissionOptions.map((permission,index)=>{
                  const detail=getVisitorPermissionDetail(visitorPermissionDetails,permission.value);
                  const currentValue=Object.prototype.hasOwnProperty.call(visitorPermissions,permission.value)?visitorPermissions[permission.value]:null;

                  return (
                    <Box key={permission.value} sx={{padding:2,borderBottom:index<visitorPermissionOptions.length-1?"1px solid #e5e7eb":"none"}}>
                      <Box sx={{display:"flex",alignItems:{xs:"flex-start",sm:"center"},justifyContent:"space-between",gap:2,flexDirection:{xs:"column",sm:"row"}}}>
                        <Box sx={{minWidth:0,flexGrow:1}}>
                          <Typography sx={{fontSize:14,fontWeight:800}}>{permission.label}</Typography>

                          {permission.value==="VISITORS_VIEW_OWN"&&(
                            <Typography sx={{color:"#6b7280",fontSize:12,marginTop:0.3}}>
                              Permite ver únicamente las invitaciones creadas por este usuario.
                            </Typography>
                          )}

                          {permission.value==="VISITORS_VIEW_ALL"&&(
                            <Typography sx={{color:"#6b7280",fontSize:12,marginTop:0.3}}>
                              Permite ver todas las invitaciones creadas dentro del tenant.
                            </Typography>
                          )}

                          {permission.value==="VISITORS_CREATE"&&(
                            <Typography sx={{color:"#6b7280",fontSize:12,marginTop:0.3}}>
                              Permite crear invitados y generar sus códigos de acceso.
                            </Typography>
                          )}

                          {permission.value==="VISITORS_EDIT"&&(
                            <Typography sx={{color:"#6b7280",fontSize:12,marginTop:0.3}}>
                              Permite modificar invitaciones dentro del alcance de visualización del usuario.
                            </Typography>
                          )}

                          {permission.value==="VISITORS_CANCEL"&&(
                            <Typography sx={{color:"#6b7280",fontSize:12,marginTop:0.3}}>
                              Permite cancelar invitaciones dentro del alcance del usuario.
                            </Typography>
                          )}

                          {permission.value==="VISITORS_MANAGE"&&(
                            <Typography sx={{color:"#6b7280",fontSize:12,marginTop:0.3}}>
                              Da control total sobre el módulo de visitantes.
                            </Typography>
                          )}

                          <Typography sx={{fontSize:11,fontWeight:700,color:detail?.inherited===true?"#166534":"#6b7280",marginTop:0.7}}>
                            {getInheritedLabel(detail)}
                          </Typography>
                        </Box>

                        <FormControl size="small" sx={{minWidth:{xs:"100%",sm:190},flexShrink:0}}>
                          <Select
                            value={currentValue===true?"allow":currentValue===false?"deny":"inherit"}
                            onChange={event=>{
                              const value=event.target.value;
                              onVisitorPermissionChange(permission.value,value==="allow"?true:value==="deny"?false:null);
                            }}
                          >
                            <MenuItem value="inherit">Heredar del rol</MenuItem>
                            <MenuItem value="allow">Permitir</MenuItem>
                            <MenuItem value="deny">Denegar</MenuItem>
                          </Select>
                        </FormControl>
                      </Box>

                      <Typography sx={{fontSize:11,fontWeight:700,color:currentValue===true?"#166534":currentValue===false?"#b91c1c":"#6b7280",marginTop:1}}>
                        Resultado: {getEffectiveLabel(detail,currentValue)}
                      </Typography>
                    </Box>
                  );
                })}
              </Stack>
            )}
          </Box>

          <Box sx={{padding:1.5,border:"1px solid #dbeafe",borderRadius:2,backgroundColor:"#eff6ff"}}>
            <Typography sx={{color:"#1e40af",fontSize:12,fontWeight:700}}>
              Los permisos individuales tienen prioridad sobre los permisos heredados del rol. Si seleccionas "Heredar del rol", se elimina la excepción individual.
            </Typography>
          </Box>
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={saving}>Cancelar</Button>
        <Button variant="contained" onClick={onSave} disabled={saving||visitorPermissionsLoading}>
          {saving?<CircularProgress size={20} sx={{color:"#ffffff"}}/>:form.id?"Guardar cambios":"Crear permiso"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}